function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import ItemCardBackground from './ItemCardBackground';
import ThetanButton from '@profile/src/Components/ThetanButton_V2';
import Glow from './Glow';
import { useTypedSelector } from '@profile/src/redux/utils';
import { useOpenThetanBoxContext } from '@profile/src/Profile_V2/OpenThetanBoxProvider';
import { getBox } from '../utils';
import Text from '@profile/src/Components/Text';
import { useTestId } from '@wolffun/testable-id';

const ItemCard = ({
  item,
  className,
  config
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const isDisable = !item.amount;
  const boxConfigs = useTypedSelector(state => {
    var _state$boxConfigsV2$d;

    return (_state$boxConfigsV2$d = state.boxConfigsV2.data) === null || _state$boxConfigsV2$d === void 0 ? void 0 : _state$boxConfigsV2$d.boxConfigs;
  });
  const {
    startOpenThetanBox
  } = useOpenThetanBoxContext();
  const boxConfig = React.useMemo(() => {
    if (boxConfigs) {
      return getBox(boxConfigs, item.boxType);
    }

    return undefined;
  }, [boxConfigs, item.boxType]);
  return /*#__PURE__*/React.createElement("div", _extends({}, generateTestIdProps('box-item'), {
    onClick: () => {
      if (boxConfig) startOpenThetanBox(item.amount, boxConfig);
    },
    className: classNames(styles.container, className, styles.ItemCard)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: styles.img,
    src: config.imgPath
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement(Text, _extends({}, generateTestIdProps('box-type'), {
    className: styles.name,
    numberOfLines: 1
  }), `${config.name} Box`), /*#__PURE__*/React.createElement("div", {
    className: styles.sub
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.spanSub
  }, "You have:\xA0", /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('box-amount'), {
    className: styles.count
  }), item.amount, " Boxes"))), /*#__PURE__*/React.createElement("div", {
    className: styles.processing
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.spanProcessing
  }, item.processing ? `Transferring in-process: ${item.processing} Boxes` : undefined))), /*#__PURE__*/React.createElement(ThetanButton, _extends({}, generateTestIdProps('box-open'), {
    disabled: isDisable,
    className: styles.button,
    title: "Open Box"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.bg, className)
  }, /*#__PURE__*/React.createElement(ItemCardBackground, {
    src: config.bgPath,
    className: styles.top
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.circle, styles.ellipse)
  }), /*#__PURE__*/React.createElement(Glow, {
    color: config.textColor,
    className: classNames(styles.circle, styles.ellipse)
  })));
};

export default ItemCard;